/* @flow */
import * as React from 'react';

const TakePicture = props => (
  <svg
    width={80}
    height={93}
    viewBox="0 0 80 93"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <path
      fill="#DEDEDE"
      d="M60.811,83.114 C60.837,83.35 60.877,83.583 60.926,83.816 C59.656,85.172 57.856,86.026 55.856,86.026 L30.37,86.026 C30.57,85.173 30.57,84.259 30.316,83.335 C30.278,83.197 30.23,83.062 30.18,82.928 L55.856,82.928 C57.917,82.928 59.592,81.297 59.692,79.26 C59.74,79.277 59.79,79.291 59.839,79.306 C59.884,79.377 59.927,79.453 59.972,79.512 C59.998,79.588 60.028,79.662 60.053,79.739 C60.271,80.487 60.486,81.225 60.638,81.99 C60.655,82.076 60.7,82.4 60.744,82.686 C60.758,82.841 60.783,83.029 60.811,83.114 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M58.181,36.576 L74.674,27.267 C76.688,26.058 78.04,23.86 78.04,21.341 C78.04,17.522 74.944,14.426 71.126,14.426 C69.234,14.426 66.273,16.418 66.273,16.418 L58.032,21.297 C55.854,22.504 53.414,25.075 53.414,28.211"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M13.242,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,17.019"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      fill="none"
      d="M13.242,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,17.019"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#1B1E33"
      d="M61.259,66.226 L61.259,6.904 C61.259,3.92 58.84,1.5 55.855,1.5 L18.646,1.5 C15.662,1.5 13.243,3.92 13.243,6.904 L13.243,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,66.226 Z"
    />
    <polygon fill="#FFFFFF" points="13.243 71.61 61.259 71.61 61.259 10.401 13.243 10.401" />
    <rect fill="#D8D8D8" opacity={0.400000006} x={26} y={12} width={2} height={36} />
    <rect fill="#D8D8D8" opacity={0.400000006} x={46} y={12} width={2} height={36} />
    <rect fill="#D8D8D8" opacity={0.400000006} x={15} y={20} width={45} height={2} />
    <rect fill="#D8D8D8" opacity={0.400000006} x={15} y={39} width={45} height={2} />
    <rect fill="#677BC5" x={14} y={48} width={46} height={26} />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M61.259,66.226 L61.259,6.904 C61.259,3.92 58.84,1.5 55.855,1.5 L18.646,1.5 C15.662,1.5 13.243,3.92 13.243,6.904 L13.243,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,66.226 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle fill="#FFFFFF" cx={37} cy={60} r={9} />
    <polygon fill="none" points="31 54 43 54 43 66 31 66" />
    <circle fill="#1C1F34" fillRule="nonzero" cx={37} cy={60} r={1.6} />
    <path
      fill="#1C1F34"
      fillRule="nonzero"
      d="M35.5,55 L34.585,56 L33,56 C32.45,56 32,56.45 32,57 L32,63 C32,63.55 32.45,64 33,64 L41,64 C41.55,64 42,63.55 42,63 L42,57 C42,56.45 41.55,56 41,56 L39.415,56 L38.5,55 L35.5,55 Z M37,62.5 C35.62,62.5 34.5,61.38 34.5,60 C34.5,58.62 35.62,57.5 37,57.5 C38.38,57.5 39.5,58.62 39.5,60 C39.5,61.38 38.38,62.5 37,62.5 Z"
    />
    <path fill="#FFFFFF" d="M61.259,10.401 L13.243,10.401" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M61.259,10.401 L13.243,10.401"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path fill="#FFFFFF" d="M13.242,72.843 L61.258,72.843" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M13.242,72.843 L61.258,72.843"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M13.242,47.731 C13.242,43.527 10.934,41.202 8.363,39.916 C5.21,38.338 1.5,40.656 1.5,44.181 L1.5,52.778 L1.5,78.641 C1.5,78.641 1.722,84.455 4.024,90.463"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M30.797,90.685 C30.797,68.164 13.538,66.225 13.538,66.225 L8.646,66.225 L8.646,92.294 L30.797,90.685 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M13.242,66.226 C13.242,66.226 30.343,68.147 30.343,90.46"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M72.151,40.777 C72.151,44.596 69.055,47.691 65.237,47.691 C61.418,47.691 58.322,44.596 58.322,40.777 C58.322,36.958 61.418,33.863 65.237,33.863 C69.055,33.863 72.151,36.958 72.151,40.777"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M72.151,40.777 C72.151,44.596 69.055,47.691 65.237,47.691 C61.418,47.691 58.322,44.596 58.322,40.777 C58.322,36.958 61.418,33.863 65.237,33.863 C69.055,33.863 72.151,36.958 72.151,40.777 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M70.188,54.627 C70.188,58.447 67.092,61.541 63.274,61.541 C59.455,61.541 56.359,58.447 56.359,54.627 C56.359,50.809 59.455,47.714 63.274,47.714 C67.092,47.714 70.188,50.809 70.188,54.627"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M70.188,54.627 C70.188,58.447 67.092,61.541 63.274,61.541 C59.455,61.541 56.359,58.447 56.359,54.627 C56.359,50.809 59.455,47.714 63.274,47.714 C67.092,47.714 70.188,50.809 70.188,54.627 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M68.225,68.478 C68.225,72.297 65.129,75.392 61.311,75.392 C57.492,75.392 54.396,72.297 54.396,68.478 C54.396,64.659 57.492,61.564 61.311,61.564 C65.129,61.564 68.225,64.659 68.225,68.478"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M68.225,68.478 C68.225,72.297 65.129,75.392 61.311,75.392 C57.492,75.392 54.396,72.297 54.396,68.478 C54.396,64.659 57.492,61.564 61.311,61.564 C65.129,61.564 68.225,64.659 68.225,68.478 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M56.763,90.462 C59.214,86.959 61.259,82.261 61.259,76.341"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M1.5,53.615 L4.012,53.615 C4.012,53.615 5.463,53.52 6.093,52.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TakePicture;



// WEBPACK FOOTER //
// ./src/assets/images/icons/take-picture.js